import type {
  GetExecutionPlanRequest,
  GetExecutionPlanResult,
  ImportExecutionPlanRequest,
  ImportExecutionPlanResult,
  ExportExecutionPlanRequest,
  ExportExecutionPlanResult,
} from '../../../../types/executionPlan';

export async function getExecutionPlan(
  request: GetExecutionPlanRequest
): Promise<GetExecutionPlanResult> {
  if (!window.electronAPI?.getExecutionPlan) {
    return { success: false, error: 'Electron API is not available' };
  }

  try {
    return await window.electronAPI.getExecutionPlan(request);
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error fetching execution plan',
    };
  }
}

export async function exportExecutionPlan(
  request: ExportExecutionPlanRequest
): Promise<ExportExecutionPlanResult> {
  if (!window.electronAPI?.exportExecutionPlan) {
    return { success: false, error: 'Electron API is not available' };
  }

  try {
    return await window.electronAPI.exportExecutionPlan(request);
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error exporting execution plan',
    };
  }
}

export async function importExecutionPlan(
  request: ImportExecutionPlanRequest
): Promise<ImportExecutionPlanResult> {
  if (!window.electronAPI?.importExecutionPlan) {
    return { success: false, error: 'Electron API is not available' };
  }

  try {
    return await window.electronAPI.importExecutionPlan(request);
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error importing execution plan',
    };
  }
}
